export const getPaginationModel = (currentPage, totalPages) => {
  const model = [];

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      model.push(i);
    }
  } else {
    model.push(1);
    if (currentPage > 3) {
      model.push('...');
    }
    if (currentPage > 2) {
      model.push(currentPage - 1);
    }
    if (currentPage !== 1 && currentPage !== totalPages) {
      model.push(currentPage);
    }
    if (currentPage < totalPages - 1) {
      model.push(currentPage + 1);
    }
    if (currentPage < totalPages - 2) {
      model.push('...');
    }
    model.push(totalPages);
  }

  return model;
};